<template>
	<BaseModal @close="$emit('cancel')">
		<template #title>Moving sessions with labels</template>

		<p>Labels applied to these sessions will be removed when you move them to another workspace.</p>

		<template #footer>
			<BaseButton class="link-gray text-strong-base" @click="$emit('cancel')">Cancel</BaseButton>
			<BaseButton class="button-blue" @click="$emit('confirm')">Move anyway</BaseButton>
		</template>
	</BaseModal>
</template>

<script>
export default {
	name: 'ModalMovingSessionWithLabel',
	emits: ['cancel', 'confirm'],
}
</script>
